import React, { forwardRef } from "react";
import { DisplayProps } from "./interfaces";

interface FlexProps extends React.HTMLAttributes<HTMLDivElement>, DisplayProps {
  gap?: string | number;
  direction?: "row" | "column" | "row-reverse" | "column-reverse";
  justify?: string;
  align?: string;
  wrap?: "wrap" | "nowrap" | "wrap-reverse";
  fill?: boolean;
  children?: React.ReactNode;
}

const Flex = forwardRef<HTMLDivElement, FlexProps>(
  (
    {
      gap,
      direction = "row",
      justify = "flex-start",
      align = "flex-start",
      wrap = "nowrap",
      fill,
      className,
      style,
      position,
      top,
      right,
      bottom,
      left,
      width,
      height,
      zIndex,
      pointerEvents,
      overflow,
      opacity,
      display = "flex",
      ...rest
    },
    ref
  ) => {
    const styles: React.CSSProperties = {
      display,
      flexDirection: direction,
      justifyContent: justify,
      alignItems: align,
      flexWrap: wrap,
      gap: gap ? (typeof gap === "number" ? `${gap}px` : gap) : undefined,
      ...(fill && { width: "100%", height: "100%" }),
      ...(position && { position: position as any }),
      ...(top !== undefined && { top }),
      ...(right !== undefined && { right }),
      ...(bottom !== undefined && { bottom }),
      ...(left !== undefined && { left }),
      ...(width !== undefined && {
        width: typeof width === "number" ? `${width}px` : width,
      }),
      ...(height !== undefined && {
        height: typeof height === "number" ? `${height}px` : height,
      }),
      ...(zIndex !== undefined && { zIndex }),
      ...(pointerEvents && { pointerEvents }),
      ...(overflow && { overflow }),
      ...(opacity !== undefined && {
        opacity: typeof opacity === "number" ? opacity : opacity,
      }),
      ...style,
    };

    return <div ref={ref} className={className} style={styles} {...rest} />;
  }
);

Flex.displayName = "Flex";

export { Flex };
export type { FlexProps };
